<script lang="js">

  export default  {
    name: 'src-components-nav-bar',
    props: [],
    mounted () {

    },
    data () {
      return {
        drawerOpen:false,
      }
    },
    methods: {
      logout() {
        this.$store.commit('user',null)
        this.$router.push('/')
      }
    },
    computed: {
      datasource() {
        return window.datasource
      }
    }
}


</script>

<template lang="pug">
section.src-components-nav-bar
  v-app-bar(color="#703154" dark flat clipped-left app)
    nav
      v-btn(icon @click="$router.go(-1)") #[v-icon mdi-arrow-left]       
      router-link.ma-2(to="/")
        v-icon mdi-home
    h3 {{ $route.name }} 
    v-spacer
    //Agregar elementos adicionales aquí
    router-view(name="toolbar")
  v-navigation-drawer.pa-0(v-model='drawerOpen' left app clipped permanent expand-on-hover)

    v-list
      v-list-item.px-2
        v-list-item-avatar
          v-icon mdi-account
      v-list-item(link='')
        v-list-item-content
          v-list-item-title.text-h6
            | {{ $store.state.user.apodo || $store.state.user.username }}
    v-divider
    v-list
      //v-list-item(link @click="$router.push('/menu')")
          v-list-item-icon comprafecha
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Resumen
      v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/')")
        v-list-item-icon
          v-icon mdi-newspaper-variant-outline
        v-list-item-title Estado actual           

      v-list-item(link @click="$router.push('/cajas')")
        v-list-item-icon
          v-icon mdi-newspaper-variant-outline
        v-list-item-title Cajas

      v-list-group(prepend-icon="mdi-folder")
        template(v-slot:activator)
          v-list-item-title Auditoria
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/borrados')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Ventas con Eliminaciones
        v-list-item(link @click="$router.push('/auditoria')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Auditoria
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/comandas')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Comandas
      v-list-group(prepend-icon="mdi-folder")
        template(v-slot:activator)
          v-list-item-title Ventas
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/vtafecha')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Ventas Por Fecha
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/vtadetalle')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Ventas Con Detalle
        v-list-item(link @click="$router.push('/vtamp')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Medios de Pago          
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/vtahora')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Ventas Por Hora
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/ranking')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Ranking de platos
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/descuentos')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Descuentos
      v-list-group(prepend-icon="mdi-folder")
        template(v-slot:activator)
          v-list-item-title Costos
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/comprafecha')")
          v-list-item-icon 
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Compras Por Fecha
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/cmv')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Costo Venta (CMV)
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/faststock')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Stock
      v-list-group(prepend-icon="mdi-folder")
        template(v-slot:activator)
          v-list-item-title Estadisticas
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/movimientos')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Ingresos Egresos       
      v-list-group(prepend-icon="mdi-folder")
        template(v-slot:activator)
          v-list-item-title Productos
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/actprecios')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Actualizar Precios              
        v-list-item(:disabled="datasource=='MI'" link @click="$router.push('/precios')")
          v-list-item-icon
            v-icon mdi-newspaper-variant-outline
          v-list-item-title Lista de Precios       
      v-spacer
      v-list-item(link @click="logout()")
        v-list-item-icon
          v-icon mdi-logout
        v-list-item-title Cerrar Sesión                
//      v-list-item(link @click="$router.push('/cajaresumen')")
        v-list-item-icon
          v-icon mdi-account-multiple
        v-list-item-title Resumenes de Caja
</template>


<style scoped lang="scss">
  .src-components-nav-bar {
    
  }
</style>
